import { createContext } from "react";

const defaultState = {
    isExpandALL: true
}
export const IsExpandAllContext = createContext(defaultState);